module.exports = __webpack_public_path__ + "img/logo-small.12cdb7a5.png";